<template>
  <TemplatePage
    :seo-title="get_seoPage.title"
    :seo-description="get_seoPage.description"
    :twitter-img-url="seoImg.tw"
    :og-img-url="seoImg.og"
    :is-bread-top="false"
    class="view-mode"
  >
    <SkeletonWidgets
      v-if="get_sectionViewLayout.isLoading || get_sectionList.isLoading"
      :error="get_sectionViewLayout.error"
    />

    <div
      v-else-if="isLayoutExpand"
      class="view-mode__list"
    >
      <SkeletonExpandList
        v-if="get_sectionViewList.isLoading && !get_sectionViewList.data"
        :items="15"
      />

      <ExpandList
        v-if="get_sectionViewList.data"
        :key="$route.params[$options.static.PARAM_PAGE]"
        :query-key="$route.params[$options.static.PARAM_PAGE]"
        :fetch-method="fetch_sectionViewList"
        :param-page="$route.params[$options.static.PARAM_PAGE]"
        :list-type="listType"
        :prop-data="get_sectionViewList.data"
        is-auto-pagination
        is-promotion-provider
      />
    </div>

    <div
      v-else
      class="view-mode__widgets"
    >
      <TypeWidgets
        v-for="(widget, i) in widgetList"
        :key="widget.modelId + widget.modelType"
        :index="i"
        :widget="widget"
        :current-section="currentSection"
      />
    </div>
  </TemplatePage>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TypeWidgets from '~/components/Lobby/TypeWidgets'
import ExpandList from '~/components/Lobby/ExpandList'
import SkeletonWidgets from '~/components/shared/Skeletons/SkeletonWidgets'
import TemplatePage from '~/components/Base/TemplatePage'
import SkeletonExpandList from '~/components/Lobby/Skeletons/SkeletonExpandList'
import { PARAM_PAGE, VIEW_MODE, QUERY, ENUM_CATEGORY } from '@/components/Lobby/enum.js'

export default {
  name: 'ViewMode',
  components: {
    TypeWidgets,
    ExpandList,
    SkeletonWidgets,
    TemplatePage,
    SkeletonExpandList,
  },
  static: {
    PARAM_PAGE,
  },
  async fetch() {
    if (!this.isLayoutExpand) {
      await this.fetch_sectionViewLayout({ term: this.paramPage })
    }
    else {
      await this.fetch_sectionViewList({ term: this.paramPage, take: 20 })
    }
    await this.fetch_seoPage(this.$route.path)
  },
  head() {
    const isHasQueryPage = this.$route.query[`${QUERY.PAGE}_${this.$route.params[PARAM_PAGE]}`]
    if (this.isLayoutExpand && isHasQueryPage) {
      return {
        meta: [{ name: 'robots', content: 'noindex, follow' }],
      }
    }
  },
  computed: {
    ...mapGetters('lobby', [
      'get_sectionList',
      'get_sectionViewLayout',
      'get_sectionViewList',
      'get_currentSection',
    ]),
    ...mapGetters('seo', ['get_seoPage']),
    seoImg() {
      const currentUrl = this.$route.params[PARAM_PAGE]
      let og = ''
      let tw = ''

      switch (currentUrl) {
      case ENUM_CATEGORY.PROVIDERS.TERM:
        og = '/img/seo/lobby/vendor_1200_630.jpg'
        tw = '/lobby/vendor_1200_1200.jpg'
        break
      case ENUM_CATEGORY.SLOTS.TERM:
        og = '/img/seo/lobby/slots-games_1200_1200.jpg'
        tw = '/img/seo/lobby/slots-games_1200_630.jpg'
        break
      case ENUM_CATEGORY.COLLECTIONS.TERM:
        og = '/img/seo/lobby/catalog_1200_630.jpg'
        tw = '/img/seo/lobby/catalog_1200_1200.jpg'
        break
      case ENUM_CATEGORY.LIVE.TERM:
        og = '/img/seo/lobby/game_1200_630.jpg'
        tw = '/img/seo/lobby/game_1200_1200.jpg'
        break
      default:
        og = '/img/seo/lobby/slots-games_1200_1200.jpg'
        tw = '/img/seo/lobby/slots-games_1200_630.jpg'
      }

      return { og, tw }
    },
    queryLayout() {
      return this.$route.query[QUERY.LAYOUT]
    },
    isLayoutDefault() {
      return !this.$route.query[QUERY.LAYOUT]
    },
    isLayoutExpand() {
      return this.queryLayout === VIEW_MODE.EXPAND
    },
    paramPage() {
      return this.$route.params[PARAM_PAGE]
    },
    widgetList() {
      const layout = this.get_sectionViewLayout?.data?.layout
      if (!layout) return []

      return layout
    },
    currentSection() {
      return this.get_currentSection(this.$route)
    },
    viewModeSection() {
      return this.currentSection?.viewMode === VIEW_MODE.EXPAND
    },
    listType() {
      return this.currentSection?.listType
    },
  },
  watch: {
    isLayoutDefault() {
      this.changeLayout()
    },
  },
  destroyed() {
    this.reset_sectionView({ type: VIEW_MODE.EXPAND })
    this.reset_sectionView({ type: VIEW_MODE.DEFAULT })
  },
  methods: {
    ...mapActions('lobby', [
      'fetch_sectionViewLayout',
      'fetch_sectionViewList',
      'reset_sectionView',
    ]),
    ...mapActions('seo', ['fetch_seoPage']),
    changeLayout() {
      if (this.isLayoutDefault) {
        this.reset_sectionView({ type: VIEW_MODE.EXPAND })
        this.fetch_sectionViewLayout({ term: this.paramPage })
      }
      if (this.isLayoutExpand) {
        this.reset_sectionView({ type: VIEW_MODE.DEFAULT })
        this.fetch_sectionViewList({ term: this.paramPage, take: 20 })
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
